import type { ZodObject, ZodRawShape } from 'zod';
import { z } from 'zod';

/**
 * Generates the pagination form schema with a dynamic total page count provided
 * from the totalPages parameter.
 */
export function getPaginationFormSchema(totalPages: number): ZodObject<ZodRawShape> {
  const schema = z.object({
    pageSize: z.coerce.number(),
    page: z.coerce.number().gte(1).lte(totalPages),
    recordOfTotalItems: z.number()
  });
  return schema;
}

/**
 * A number must be passed to the schema generation function to validate the
 * dynamic maximum page number, but it is not used in the inferred type.
 */
const paginationFormSchema = getPaginationFormSchema(0);
export type PaginationFormValues = z.infer<typeof paginationFormSchema>;
